import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

class FilterableController extends Controller {
  static targets = ['list', 'empty', 'autofocus', 'hideOnEmpty']

  connect () {
    if (this.hasAutofocusTarget) {
      this.autofocusTarget.focus()
    }
  }

  filter (e) {
    const filterTerm = this.#normalize(e.target.value)

    const result = this.listTargets.filter((el) => {
      const filterableKey = this.#normalize(el.getAttribute('data-filter-key'))

      el.classList.toggle('hidden', !filterableKey.includes(filterTerm))

      if (filterableKey.includes(filterTerm)) {
        return el
      }

      return null
    })

    this.emptyTarget.classList.toggle('hidden', result.length > 0)
    this.hideOnEmptyTargets.forEach((el) => el.classList.toggle('hidden', result.length === 0))
  }

  clear () {
    if (this.hasAutofocusTarget) {
      this.autofocusTarget.value = ''
      this.autofocusTarget.focus()
    }

    this.listTargets.forEach((el) => el.classList.remove('hidden'))
    this.hideOnEmptyTargets.forEach((el) => el.classList.remove('hidden'))
    this.emptyTarget.classList.add('hidden')
  }

  preventSubmit (e) {
    e.preventDefault()
  }

  #normalize (value) {
    return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  }
}

stimulus.register('filterable', FilterableController)
